import Calculator from './Calculator';

export default Calculator;

export const calculatePoints = ({programs = [], yearBorn = '', additionalPoints = ''}) => {
    let gradesTotal = 0;
    let gradesCount = 0;
    let forGrades = 0;
    let forAge = 0;
    let forExtras = 0;
    let forLanguage = 0;

    if(programs.length > 0) {
        programs.forEach(program => {
            if(program.grade) gradesCount ++;
            if(program.examGrade) gradesCount ++;
            if(program.exam2Grade) gradesCount ++;
            if(program.languagePoints) forLanguage += program.languagePoints;
            
            gradesTotal += program.grade + (program.examGrade || 0) + (program.exam2Grade || 0);
        });

        forGrades = (gradesTotal / gradesCount) * 10 || 0;
    }

    const currentYear = new Date().getFullYear();

    if(yearBorn) {
        if(Number(yearBorn) === (currentYear - 20)) forAge = 2; // current year - 20 ( 1998 in 2018 )
        if(Number(yearBorn) === (currentYear - 21)) forAge = 4; // current year - 21 ( 1997 in 2018 )
        if(Number(yearBorn) === (currentYear - 22)) forAge = 6; // current year - 22 (1996 in 2018 )
        if(Number(yearBorn) <= (currentYear - 23)) forAge = 8; // current year - 23 ( 1995 in 2018 )
    }

    if(additionalPoints.haCredits3059) forExtras = 1;
    if(additionalPoints.passedService || additionalPoints.approvedYear || additionalPoints.haCredits60 ) forExtras = 2;

    if(forLanguage > 4) {
        forLanguage = 4;
    }
    
    return {
        forGrades: forGrades.toFixed(1),
        forAge: forAge.toFixed(1),
        forExtras: forExtras.toFixed(1),
        forLanguage: forLanguage.toFixed(1),
        total: (forGrades + forAge + forExtras + forLanguage).toFixed(1)
    }
}


// WEBPACK FOOTER //
// ./src/partials/modules/Calculator/index.js